import {INIT_NOTIFICATION_STATE, NotificationState} from './notification.state';
import {NotificationActionType} from './notification.actions';

export function notificationReducer(state= INIT_NOTIFICATION_STATE, action: any): NotificationState {
    const payload = action.payload;
    switch (action.type) {
        case NotificationActionType.NOTIFICATION_TOKEN_REQUESTED:
            return {
                ...state,
                fetchInProgress: true,
                error: null
            };
        case NotificationActionType.NOTIFICATION_TOKEN_FETCH_SUCCEEDED:
            return {
                ...state,
                fetchInProgress: false,
                notificationData: {...state.notificationData, token: payload.token}
            };
        case NotificationActionType.NOTIFICATION_TOKEN_FETCH_FAILED:
            return {
                ...state,
                fetchInProgress: false,
                error: payload.error
            };
        case NotificationActionType.NOTIFICATION_TOKEN_PERSIST:
            return {
                ...state,
            };
        case NotificationActionType.NOTIFICATION_TOKEN_PERSIST_SUCCEEDED:
            return {
                ...state,
                notificationData: {...state.notificationData, token: payload.token}
            };
        case NotificationActionType.NOTIFICATION_TOKEN_PERSIST_FAILED:
            return {
                ...state,
                error: payload.error
            };
        case NotificationActionType.NOTIFICATION_TOKEN_CLEAR:
            return {
                ...state,
                notificationData: {...state.notificationData, token: undefined},
            };
        case NotificationActionType.NOTIFICATION_BODY_ARRIVED:
            return {
                ...state,
                notificationData: {...state.notificationData, token: payload.body},
            };
        case NotificationActionType.NOTIFICATION_BODY_CLEAR:
            return {
                ...state,
                notificationData: {...state.notificationData, body: undefined},
            };
        default:
            return state;
    }
}
